import React, { useState } from 'react';

export default function SchoolLoginDesign3() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  return (
    <div className="min-h-screen bg-gray-950 flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        <div className="bg-gray-900 border border-gray-800 rounded-2xl shadow-2xl overflow-hidden">
          {/* Header */}
          <div className="px-8 py-16 text-center bg-gradient-to-b from-gray-800 to-gray-900 border-b border-gray-800">
            <div className="flex justify-center mb-6">
              <div className="w-16 h-16 bg-gradient-to-br from-cyan-400 to-blue-500 rounded-2xl flex items-center justify-center">
                <span className="text-3xl">🏫</span>
              </div>
            </div>
            <h1 className="text-3xl font-black text-white mb-2">NEXUS SCHOOL</h1>
            <p className="text-cyan-400 font-light">Next Generation Management</p>
          </div>

          {/* Form */}
          <div className="px-8 py-12 space-y-6">
            <div>
              <label className="block text-xs font-bold text-gray-400 mb-3 uppercase tracking-widest">Email Address</label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="admin@nexusschool.com"
                className="w-full px-4 py-3 bg-gray-800 border border-gray-700 rounded-lg text-white placeholder-gray-500 focus:outline-none focus:border-cyan-500 focus:ring-1 focus:ring-cyan-400 transition"
              />
            </div>

            <div>
              <label className="block text-xs font-bold text-gray-400 mb-3 uppercase tracking-widest">Password</label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="••••••••"
                className="w-full px-4 py-3 bg-gray-800 border border-gray-700 rounded-lg text-white placeholder-gray-500 focus:outline-none focus:border-cyan-500 focus:ring-1 focus:ring-cyan-400 transition"
              />
            </div>

            <div className="flex items-center justify-between">
              <label className="flex items-center gap-2 text-sm text-gray-400">
                <input type="checkbox" className="w-4 h-4 bg-gray-800 border border-gray-700 rounded cursor-pointer" />
                Remember login
              </label>
              <a href="#" className="text-sm text-cyan-400 hover:text-cyan-300 font-semibold">Need Help?</a>
            </div>

            <button className="w-full bg-gradient-to-r from-cyan-500 to-blue-600 text-white font-bold py-3 rounded-lg hover:from-cyan-600 hover:to-blue-700 transition duration-300 shadow-lg hover:shadow-cyan-500/50">
              ACCESS SYSTEM
            </button>

            <div className="grid grid-cols-3 gap-2 pt-4">
              <button className="py-2 bg-gray-800 border border-gray-700 rounded text-gray-400 text-xs font-semibold hover:border-gray-600 transition">ADMIN</button>
              <button className="py-2 bg-gray-800 border border-gray-700 rounded text-gray-400 text-xs font-semibold hover:border-gray-600 transition">TEACHER</button>
              <button className="py-2 bg-gray-800 border border-gray-700 rounded text-gray-400 text-xs font-semibold hover:border-gray-600 transition">PARENT</button>
            </div>
          </div>

          {/* Footer */}
          <div className="bg-gray-900 border-t border-gray-800 px-8 py-4 text-center">
            <p className="text-xs text-gray-500">© 2024 Nexus School Management System</p>
          </div>
        </div>
      </div>
    </div>
  );
}
